import CodeSnippet from "src/components/general/CodeSnippet/CodeSnippet";

interface ToolCallIndicatorCompletedOutputProps {
  isError: boolean;
  isEmpty: boolean;
  formattedBody: string;
}

// Tool results above this size get plain rendering instead of Prism syntax
// highlighting. PrismLight tokenizes synchronously per render and produces a
// React node per token, which is catastrophic for large JSON dumps from MCP
// tools (e.g. listing thousands of items). 20 KB picks up typical structured
// responses while excluding the pathological ones.
const SYNTAX_HIGHLIGHT_MAX_BODY_BYTES = 20 * 1024;
const CODE_SNIPPET_CLASSNAME =
  "text-error dark:text-error-light text-xs font-semibold";

export default function ToolCallIndicatorCompletedOutput({
  isError,
  isEmpty,
  formattedBody,
}: ToolCallIndicatorCompletedOutputProps) {
  // Approximation: JS string length ≈ byte count for ASCII-heavy tool output.
  const skipSyntaxHighlighting =
    formattedBody.length > SYNTAX_HIGHLIGHT_MAX_BODY_BYTES;

  if (isError) {
    return (
      <CodeSnippet
        title={<div className={CODE_SNIPPET_CLASSNAME}>Error</div>}
        code={formattedBody}
        sentiment="negative"
        withoutSyntaxHighlighting={skipSyntaxHighlighting}
        className="max-h-72"
      />
    );
  }
  if (isEmpty) {
    return (
      <CodeSnippet
        title={<div className={CODE_SNIPPET_CLASSNAME}>404</div>}
        code="No response returned from tool"
        sentiment="negative"
        className="max-h-72"
        withoutCopy
      />
    );
  }
  return (
    <CodeSnippet
      code={formattedBody}
      sentiment="positive"
      withoutSyntaxHighlighting={skipSyntaxHighlighting}
      className="max-h-72"
    />
  );
}
